<template>
	<!-- 导航栏 -->
	<div class="headerNavClass">
		<div class="tittle flex navContentClass">
			<div class="logo fl" style="margin-left: 35px">
				<img src="../../assets/logo.png" alt="" @click="getHome" />
				<!--        <h5>3D打印工业互联网平台</h5>-->
			</div>
			<div class="mapName flex">
				<div class="flex tittle_ul">
					<li v-for="(items, index) in maplist" :key="index" @mouseenter="solutionMouseOver(items.name)"
						@click="mapNameList(items.linkUrl, items.value, items.name)" :ref="'navItemRef' + items.value"
						:class="mapLi == items.name ? 'mapNameLi' : ''">

						{{ items.name }}
					</li>
					<solutionNavigation ref="solutionNavigationRef" @closeSolutionNavigation="closeSolutionNavigation">
					</solutionNavigation>
				</div>
			</div>
			<!-- 搜索 -->
			<div class="flex right_box userInfo">
				<!-- <div class="search">
          <i
            class="el-icon-search"
            @click="searchShowMessage"
            v-if="searchShow == false"
          ></i>
          <i class="el-icon-close" @click="searchShow = !searchShow" v-else></i>
        </div> -->

				<div class="login flex loginText" v-if="isLogin">
					<p @click="handleDocument">文档</p>
					<p @mouseenter="showTimesMessage" @mouseleave="falseTimesMessage">工作台</p>
					<p class="userName" @click="handleUesermess" ref="userName">
						HI,{{ $store.state.isUsermessage.name }}
					</p>
				</div>
				<div class="login flex loginText" v-else>
					<p @click="handleDocument">文档</p>
					<p @click="getRegisteredLogin(2)">工作台</p>
					<div class="lh90" style="margin-right: 20px" @click="getRegisteredLogin(1)">
						注册
					</div>
					<div class="lh90 the_login" @click="getRegisteredLogin(2)">登录</div>
				</div>
			</div>

			<!-- 服务和置顶 -->
			<div class="flexClass">
				<!-- <el-tooltip class="item" effect="dark" content="Left Bottom 提示文字" placement="left-end"> -->
				<p class="uploadImg" v-if="uploadFlag" @click="goModelImage" @mouseover="gotGj('0')"
					@mouseleave="gotGj('1')" data-msg="3D工具">
					<img style="width:30px;height:30px;margin-top: 10px;" :src="uploadImg">
				</p>
				<!-- </el-tooltip> -->
				<p ref="getGoTopRef" :class="uploadFlag?'el-icon-top topClass':'el-icon-top topClass1'"
					@click="getGoTop"></p>
				<!-- <p ref="getGoTopRef" :class="uploadFlag?'el-icon-top topClass':'el-icon-top topClass1'"
					@click="getGoTop"></p> -->
				<p ref="getWeiXin" class="iconfont icon-weixin topClassWeiXin" @mouseover="gotoWeiXin('0')"
					@mouseleave="gotoWeiXin('1')">
					<!-- <img style="width: 26px;height: 20px" src="../../assets/微信.png"> -->
					<!--二维码-->

					<span id="rwm"
						style="width:140px;height:150px;float:left;position:absolute;display: none;border-radius: 5px;margin-left: -180px;margin-top: -90px;background-color: white;padding:10px;box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);">
						<span class="scanCode" style="">扫码联系微信客服</span>
						<img style="width:130px;height:130px;margin-top: -14px;" src="../../assets/微信二维码.png">
					</span>
				</p>
				<p ref="gettopCharts" class="topCharts" @click="startChat" data-msg="聊天消息">
					<el-badge :value="this.$store.state.unReadMsgCount" class="item"
						:hidden="!this.$store.state.unReadMsgCount > 0">
						<i class="el-icon-chat-dot-square"></i>
					</el-badge>
				</p>
				<p ref="getGoConsult" class=" topClassCheck" @click="onlineConsult" data-msg="咨询留言">
					<i class="el-icon-service"></i>
				</p>
				
					<el-dropdown v-if="shareFlag" @visible-change ='gotShare' class="shareImg"  :hide-on-click='true'  placement='left'>
					    <span class="el-dropdown-link" style="display: inline-block;height: 100%;width: 100%;">
							<i class="iconfont icon-fenxiang-copy" style="font-size: 27px;"></i>
							<!-- <img style="width:27px;height:27px;margin-top: 12px;margin-right: 2px;" :src="shareImg"> -->
					    </span>
					    <template #dropdown>
					      <el-dropdown-menu>
					        <el-dropdown-item command="a">
									<div @click="copyLink" style="vertical-align: middle;">
										<i class="el-icon-link"></i>
										复制链接
									</div>
							</el-dropdown-item>
					        <el-dropdown-item command="b">
								<div @click="share_weibo($event)">
									<img src="../../assets/xl.png" style="width:20px;height:20px;margin-right: 5px;vertical-align: middle;" />
									<span>新浪微博</span>
								</div>
							</el-dropdown-item>
					        <el-dropdown-item command="c" disabled>
								<div>
									<img src="../../assets/wechat2.png" style="width:20px;height:20px;margin-right: 5px;vertical-align: middle;">
									微信扫一扫
								</div>
								<div id="qrcode" ref="qrcode"></div>
							</el-dropdown-item>
					      </el-dropdown-menu>
					    </template>
					  </el-dropdown>
				
				<!-- 分享 -->
			<!-- 	<p class="shareImg" v-if="shareFlag" @mouseover="gotShare()" @mouseleave="cl_gotShare()">
					<img style="width:27px;height:27px;margin-top: 12px;margin-right: 2px;" :src="shareImg">
				</p> -->
				<!-- <div v-show="share_con" class="hidden_div"> -->
					<!-- @mouseover="share_infoContinue()"@mouseout="cl_share_infoContinue()" -->
					<!-- <div class="root"></div>
					<div @click="copyLink">
						<i class="el-icon-link"></i>
						复制链接
					</div>
					<div @click="share_weibo($event)">
						<img src="../../assets/xl.png" style="width:20px;height:20px;margin-right: 5px;" />
						<span>新浪微博</span>
					</div>
					<div>
						<div>
							<img src="../../assets/wechat2.png" style="width:20px;height:20px;margin-right: 5px;">
							微信扫一扫
						</div>
						<div id="qrcode" ref="qrcode"></div> -->
						<!-- <img style="width:110px;height:110px;" src="../../assets/微信二维码.png"> -->
					<!-- </div>
				</div> -->
			</div>
		</div>
		<!-- 用户弹窗 -->
		<div v-show="uesermess" @click="closeMsg" class="userMessageBox">
			<div class="userMessage flex">
				<img v-if="$store.state.isUsermessage.headUrl == null" src="../../assets/users.png" alt=""
					@click="goToUserCenter" />
				<img v-if="$store.state.isUsermessage.headUrl != null" :src="$store.state.isUsermessage.headUrl" alt=""
					@click="goToUserCenter" />
				<div class="userMes">
					<h4 @click="goToUserCenter">
						{{ $store.state.isUsermessage.name }}
					</h4>
					<div class="userMesBox flex">
						<div class="userMesNames flex">
							<!-- <p>游客</p> -->
							<!-- <p>{{ $store.state.isUsermessage.identityCn }}</p> -->

							<p v-if="$store.state.isUsermessage.identity == 'ENTERPRISE'">
								企业认证
							</p>
							<p v-if="$store.state.isUsermessage.identity == 'STAFF'">
								企业成员
							</p>
							<p v-if="$store.state.isUsermessage.identity == 'PERSONAL'">
								个人实名认证
							</p>
							<p v-if="$store.state.isUsermessage.identity == 'ANONYMOUS'">
								游客
							</p>
							<!-- <p>企业认证</p> -->
						</div>
						<p class="noUser" @click="getNoUser">退出登录</p>
					</div>
				</div>
			</div>
		</div>
		<!-- 工作台弹窗 -->
		<!-- <div v-show="showTimes" @mouseenter="closeWorkShow" @mouseleave="closeWorks" class="worksDi" ref="showTimesRef"> -->
		<div v-show="showTimes" @mouseenter="showTimesMessage" @mouseleave="falseTimesMessage" class="worksDi" ref="showTimesRef">
			<div class="loginMess" :style="{ right: userNameWidth }">
				<!-- 解决跨域通信 -->
				<p class="usercenter" @click="getUsercenter('buyer')">买家工作台</p>
				<p class="usercenter" @click="getUsercenter('seller')" v-if="seller">卖家工作台</p>
				<p class="usercenter" @click="getUsercenter('designer')" v-if="designer">设计师工作台</p>
				<p class="usercenter" @click="getUsercenter('leader')" v-if="judger">评委中心</p>
			</div>
		</div>
		<!-- 搜索弹框 -->
		<div class="searchDialog" v-show="searchShow" @click="closeSearchShow">
			<div class="right_input" :style="{ right: searchDialogWidth }">
				<el-input placeholder="请输入搜索内容" suffix-icon="el-icon-search" v-model="input1">
				</el-input>
			</div>
		</div>

		<!--聊天窗口-->
		<chat-dialog ref="chatDialogRef"></chat-dialog>
	</div>
</template>

<script>
	import {
		mapState,
		mapMutations
	} from "vuex";
	import {
		getIndexDictionaryData,
		getNewcurrent
	} from "../../utils/interface";
	import solutionNavigation from "./solutionNavigation";
	import {
		Loading
	} from "element-ui";
	import * as RongIMLib from "@rongcloud/imlib-next";

	import chatDialog from '../chat/chatDialog'
	import QRCode from 'qrcodejs2'

	export default {
		components: {
			solutionNavigation,
			chatDialog

		},
		data() {
			return {
				// nap
				flag: false,
				uploadImg: require('../../assets/gj.png'),
				// shareImg: require('../../assets/share1.png'),
				uploadFlag: false,
				shareFlag: false,
				maplist: [],
				mapLi: "首页",
				cemera: true,
				setIn: null, // 定时器
				userName: "",
				input1: "",
				searchShow: false,
				isSolution: false,
				showTimes: false,
				uesermess: false,
				seller: false,
				designer: false,
				judger: false,
				userNameWidth: "0px",
				searchDialogWidth: "0px",
				setInTime: null,
				setInTime2: null,
				// share_con: false,
				infoContinue: false, //增加
			};
		},
		created() {
			this.setIn = setInterval(() => {
				if (this.isTokenDoor === true) {
					clearInterval(this.setIn);
					this.getMenuList();
					this.getUserMessage();
				}
			}, 500);
			setTimeout(() => {
				if (
					location.href.indexOf("print") !== -1 ||
					location.href.indexOf("printList") !== -1 ||
					location.href.indexOf("printHot") !== -1 ||
					location.href.indexOf("printServiceIndex") !== -1 ||
					location.href.indexOf("printServiceDetails") !== -1
				) {
					this.mapLi = "我要打印";
				} else if (
					location.href.indexOf("activeDetail") !== -1
				) {
					this.shareFlag = true;
					this.mapLi = "设计市场";
				} else if (
					location.href.indexOf("design") !== -1 ||
					location.href.indexOf("designModel") !== -1 ||
					location.href.indexOf("designDetails") !== -1 ||
					location.href.indexOf("designList") !== -1 ||
					location.href.indexOf("designerList") !== -1 ||
					location.href.indexOf("designRelease") !== -1 ||
					location.href.indexOf("activeList") !== -1 ||
					location.href.indexOf("activeDetail") !== -1 ||
					location.href.indexOf("worksDetails") !== -1 ||
					location.href.indexOf("winDetails") !== -1 ||
					location.href.indexOf("leaderList") !== -1 ||
					location.href.indexOf("productWork") !== -1
				) {
					this.mapLi = "设计市场";
				} else if (
					location.href.indexOf("model") !== -1 ||
					location.href.indexOf("modelDetails") !== -1 ||
					location.href.indexOf("threeDModel") !== -1
				) {
					this.mapLi = "3D模型库";
					this.uploadFlag = true;
				} else if (
					location.href.indexOf("mall") !== -1 ||
					location.href.indexOf("shopGoodsList") !== -1 ||
					location.href.indexOf("shopMallList") !== -1 ||
					location.href.indexOf("shopGoodDetails") !== -1 ||
					location.href.indexOf("shopServiceAuthentication") !== -1 ||
					location.href.indexOf("shopAffirmOrder") !== -1 ||
					location.href.indexOf("shopCar") !== -1 ||
					location.href.indexOf("MallList") !== -1 ||
					location.href.indexOf("integralActivities") !== -1 ||
					location.href.indexOf("activeShopGoodDetails") !== -1 ||
					location.href.indexOf("activeShopAffirmOrder") !== -1 ||
					location.href.indexOf("activeShopSendSuccess") !== -1 ||
					location.href.indexOf("collectActivities") !== -1 ||
					location.href.indexOf("collectShopGoodDetails") !== -1 ||
					location.href.indexOf("collectShopAffirmOrder") !== -1 ||
					location.href.indexOf("collectShopSendSuccess") !== -1
				) {
					this.mapLi = "3D商城";
				} else if (location.href.indexOf("strategy") !== -1) {
					this.mapLi = "3D课堂";
				} else if (
					location.href.indexOf("apps") !== -1 ||
					location.href.indexOf("saasDetails") !== -1 ||
					location.href.indexOf("saasList") !== -1
				) {
					this.mapLi = "应用市场";
				} else if (location.href.indexOf("model") !== -1) {
					this.mapLi = "远程思维";
				} else if (location.href.indexOf("solution") !== -1 || location.href.indexOf("solutionDetails") !==
					-1) {
					// else if (location.href.indexOf("join") !== -1)
					this.mapLi = "解决方案";
				} else if (
					location.href.indexOf("park") !== -1 ||
					location.href.indexOf("allPark") !== -1 ||
					location.href.indexOf("parkDetails") !== -1 ||
					location.href.indexOf("parkDynamic") !== -1
				) {
					this.mapLi = "园区生态";
				} else {
					this.mapLi = "首页";
				}
			}, 500)
			// console.log('location', location.href.indexOf('park'))

			// let num = this.$route.query.rrr;
		},
		mounted() {
		},
		computed: {
			...mapState({
				routerPath: "routerPath",
				isTokenDoor: "isTokenDoor",
				isLogin: "isLogin",
				isUsermessage: "isUsermessage",
				share_con: 'share_con'
			}),
		},
		watch: {
			routerPath(newVal, oldNew) {
				console.log(newVal)
				// console.log(newVal, oldNew);
				if (
					newVal.indexOf("print") !== -1 ||
					newVal.indexOf("printList") !== -1 ||
					newVal.indexOf("printHot") !== -1 ||
					newVal.indexOf("printServiceIndex") !== -1 ||
					newVal.indexOf("printServiceDetails") !== -1
				) {
					this.mapLi = "我要打印";
				} else if (
					newVal.indexOf("activeDetail") !== -1) {
					this.shareFlag = true;
				} else if (
					newVal.indexOf("design") !== -1 ||
					newVal.indexOf("designModel") !== -1 ||
					newVal.indexOf("designDetails") !== -1 ||
					newVal.indexOf("designList") !== -1 ||
					newVal.indexOf("designerList") !== -1 ||
					newVal.indexOf("designRelease") !== -1 ||
					newVal.indexOf("activeList") !== -1 ||
					newVal.indexOf("activeDetail") !== -1 ||
					newVal.indexOf("worksDetails") !== -1 ||
					newVal.indexOf("winDetails") !== -1 ||
					newVal.indexOf("leaderList") !== -1
				) {
					this.mapLi = "设计市场";
				} else if (
					newVal.indexOf("model") !== -1 ||
					newVal.indexOf("modelDetails") !== -1 ||
					newVal.indexOf("threeDModel") !== -1 
				) {
					this.mapLi = "3D模型库";
					this.uploadFlag = true;
				} else if (
					newVal.indexOf("mall") !== -1 ||
					newVal.indexOf("shopGoodsList") !== -1 ||
					newVal.indexOf("shopMallList") !== -1 ||
					newVal.indexOf("shopGoodDetails") !== -1 ||
					newVal.indexOf("shopServiceAuthentication") !== -1 ||
					newVal.indexOf("shopAffirmOrder") !== -1 ||
					newVal.indexOf("shopCar") !== -1 ||
					newVal.indexOf("integralActivities") !== -1 ||
					newVal.indexOf("activeShopGoodDetails") !== -1 ||
					newVal.indexOf("activeShopAffirmOrder") !== -1 ||
					newVal.indexOf("activeShopSendSuccess") !== -1 ||
					newVal.indexOf("collectActivities") !== -1 ||
					newVal.indexOf("collectShopGoodDetails") !== -1 ||
					newVal.indexOf("collectShopAffirmOrder") !== -1 ||
					newVal.indexOf("collectShopSendSuccess") !== -1
				) {
					this.mapLi = "3D商城";
				} else if (
					newVal.indexOf("strategy") !== -1
				) {
					this.mapLi = "3D课堂";
				} else if (
					newVal.indexOf("apps") !== -1 ||
					newVal.indexOf("saasDetails") !== -1 ||
					newVal.indexOf("saasList") !== -1
				) {
					this.mapLi = "应用市场";
				} else if (newVal.indexOf("offline") !== -1) {
					this.mapLi = "远程思维";
				} else if (
					newVal.indexOf("solution") !== -1 ||
					location.href.indexOf("solutionDetails") !== -1
				) {
					this.mapLi = "解决方案";
				} else if (
					newVal.indexOf("park") !== -1 ||
					newVal.indexOf("allPark") !== -1 ||
					newVal.indexOf("parkDetails") !== -1 ||
					newVal.indexOf("parkDynamic") !== -1
				) {
					this.mapLi = "园区生态";
				} else if (newVal.indexOf("") !== -1) {
					this.mapLi = "首页";
				} else {
					this.mapLi = "首页";
				}
			},
		},
		methods: {
			...mapMutations(["isLoginVuex", "isStorageUsermessage", "isShare_con"]),
			// 回到顶端
			getGoTop() {
				window.scroll(0, 0);
			},
			// 进入在线咨询
			onlineConsult() {
				let newToken = this.$cookies.get("api_token_new");
				if (newToken) {
					this.$router.push('/onlineConsult');
				} else {
					this.$router.push("/login");
				}
			},

			//微信二维码
			gotoWeiXin(str) {
				let rwm = document.getElementById("rwm");
				if (str == "0") {
					rwm.style.display = "block";
				} else {
					rwm.style.display = "none";
				}
			},
			//模型
			gotGj(str) {
				if (str == "0") {
					this.uploadImg = require('../../assets/gj1.png')
				} else {
					this.uploadImg = require('../../assets/gj.png');
				}
			},
			//分享
			gotShare(blo) {
				console.log(blo)
				if(blo === true){
					// this.shareImg = require('../../assets/share1.png');
					if(this.$refs.qrcode.innerHTML == ''){
						if(this.$route.params.uuid){
						this.qrcode()
						}
					}
				}
				
				// this.isShare_con(true)
				// this.shareImg = require('../../assets/share2.png');
				// this.$bus.$emit("clickshare_con", this.share_con);
			},
			cl_gotShare() {
				if (this.infoContinue = true) {
					// this.share_con = true;
					this.isShare_con(true)
				} else {
					this.isShare_con(false)
					// this.share_con = false;
				}
				// this.shareImg = require('../../assets/share1.png');
			},
			//微博分享
			share_weibo(event) {
				// event.preventDefault()
				// shareUrl是微博的分享地址，（有资料说需要真实的appkey，必选参数，这里我没用appkey也可以正常分享）
				var _shareUrl = 'http://service.weibo.com/share/share.php?'
				_shareUrl += 'url=' + encodeURIComponent(window.location.href) //参数url设置分享的内容链接
				//     _shareUrl += '&title=' + encodeURIComponent(this.titleCon) //参数title设置分享的标题
				// 保留当前页面,打开一个非tab页面（按需求来，可以新开标签页，也可以在当前页新开页面）
				window.open(
					_shareUrl,
					'_blank',
					'height=100, width=400',
					'scrollbars=yes,resizable=1,modal=false,alwaysRaised=yes'
				)
			},
			//复制地址
			copyLink() {
				let oInput = document.createElement("input");
				// 	//这边为链接地址this.liveLink='www.baidu.com'
				oInput.value = window.location.href;
				document.body.appendChild(oInput);
				oInput.select();
				document.execCommand("Copy");
				oInput.remove();
				this.$message({
					message: "复制成功",
					type: "success",
				});
			},
			//生成二维码
			qrcode() {
				// https://wx.zengcaicloud.com/#/pages/business/activities/activitiesDetails?uuid=8a7481557fbb7539017ffdfb6e940241
				let link = 'https://wx.zengcaicloud.com/#/pages/business/activities/activitiesDetails?uuid=' + this.$route
					.params.uuid + '&state=share'
				console.log(link)
				let qrcode = new QRCode('qrcode', {
					width: 132,
					height: 132,
					text: link, // 需要二维码跳转的地址
					colorDark: "#000", //前景色
					colorLight: "rgba(0,0,0,0)", //背景色
				})
			},
			// 前往用户中心
			goToUserCenter() {
				if (this.$route.fullPath == "/userCenter/00") {
					location.reload();
				} else {
					window.sessionStorage.setItem("userServeId", "00");
					this.$router.push("/userCenter/00");
				}
				this.uesermess = false;
			},
			goModelImage() {
				this.$router.push("/modelImage");
			},
			// 注销用户
			getNoUser() {
				// let apiOldToken = this.$cookies.get("api_token_old");
				// let apiNewToken = this.$cookies.get("api_token_new");
				// this.$cookies.remove("api_access_token");
				// this.$cookies.remove("api_token_new");
				this.$cookies.remove("api_access_token");
				this.$cookies.remove("api_token_new");
				this.isLoginVuex(false);

				//断开融云
				RongIMLib.disconnect().then(() => {
					console.log('成功断开')
				})

				this.$router.go();
			},
			getHome() {
				this.$router.push("/");
			},
			getMenuList() {
				getIndexDictionaryData({
						groupCode: "MH_MENU",
						current: 1,
						pageSize: 15,
					})
					.then((response) => {
						if (response.length > 0) {
							this.maplist = response;
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			// 获取用户信息
			getUserMessage() {
				getNewcurrent()
					.then((res) => {
						this.$cookies.set("authoritiesMess", ' ');
						// if (res.authorities.indexOf('designerCenterService') > -1) {
						// 	this.$cookies.set("authoritiesMess", 'designerCenterService');
						// } else if (res.authorities.indexOf('sellerCenterService') > -1) {
						// 	this.$cookies.set("authoritiesMess", 'sellerCenterService');
						// } else if (res.authorities.indexOf('reviewCenterService') > -1) {
						// 	this.$cookies.set("authoritiesMess", 'reviewCenterService');
						// }
						if (res.authorities.length !== 0) {
							res.authorities.forEach(items => {
								if (items == 'sellerCenterService') {
									this.seller = true
								} else if (items == 'designerCenterService') {
									this.designer = true
								} else if (items == 'reviewCenterService') {
									this.judger = true
								}
							})
						}
						// console.log('authoritiesMess', this.$cookies.get("authoritiesMess"));
						this.userName = res.name;
						this.isStorageUsermessage(res);
					})
					.catch((err) => {
						console.log(err);
					});
			},

			// 首页
			mapNameList(linkUrl, url, titleName) {
				if (titleName === "解决方案") {
					this.$refs.solutionNavigationRef.init(true);
					this.isSolution = true;
				} else {
					window.open(linkUrl, "_blank");
				}
			},
			// 进入注册网页/登录网页
			getRegisteredLogin(items) {
				let newToken = this.$cookies.get("api_token_new");
				if (newToken) {
					this.$router.go(0);
				} else {
					if (items == 1) {
						this.$router.push("/registered");
					} else if (items == 2) {
						this.$router.push("/login");
					}
				}
			},
			// 个人中心
			getUsercenter(user) {
				if (user == "seller") {
					let routeData = this.$url.sellerWeb;
					window.open(routeData, "_blank");
					this.$cookies.set("authoritiesMess", 'sellerCenterService');
				} else if (user == "buyer") {
					// let routeData = "http://192.168.104.36:8081";
					let routeData = this.$url.buyerWeb;
					window.open(routeData, "_blank");
					this.$cookies.set("authoritiesMess", '');
				} else if (user == "designer") {
					let routeData = this.$url.designerWeb;
					window.open(routeData, "_blank");
					this.$cookies.set("authoritiesMess", 'designerCenterService');
				} else if (user == "leader") {
					let routeData = this.$url.reviewWeb;
					window.open(routeData, "_blank");
					this.$cookies.set("reviewExamineMess", 'reviewCenterService');
					//this.$router.push('/leaderList')
				}
			},
			// 鼠标划过解决方案
			solutionMouseOver(name) {
				if (name === "解决方案") {
					this.$refs.solutionNavigationRef.init(true);
					this.$refs.getGoTopRef.style.display = "none";
					this.$refs.getGoConsult.style.display = "none";
					this.$refs.gettopCharts.style.display = "none";
					this.$refs.navItemRefsolution[0].setAttribute("class", "mapNameLi");
					this.isSolution = true;
				} else {
					this.$refs.solutionNavigationRef.init(false);
					this.$refs.getGoTopRef.style.display = "block";
					this.$refs.getGoConsult.style.display = "block";
					this.$refs.gettopCharts.style.display = "block";
					this.$refs.navItemRefsolution[0].setAttribute("class", "");
					this.isSolution = false;
				}
			},
			// 关闭解决方案弹出框恢复样式
			closeSolutionNavigation() {
				this.$refs.navItemRefsolution[0].setAttribute("class", "");
				this.$refs.getGoTopRef.style.display = "block";
				this.$refs.getGoConsult.style.display = "block";
				this.$refs.gettopCharts.style.display = "block";
				this.isSolution = false;
			},
			// 用户弹窗
			handleUesermess() {
				this.uesermess = !this.uesermess;
			},
			closeMsg(event) {
				var btn = document.querySelector(".userMessage");
				if (btn) {
					if (!btn.contains(event.target)) {
						this.uesermess = false;
					}
				}
			},
			// 工作台弹窗
			showTimesMessage() {
				this.userNameWidth = this.$refs.userName.offsetWidth + 'px'
				clearInterval(this.setInTime);
				this.showTimes = true
			},
			falseTimesMessage() {
				this.setInTime = setInterval(() => {
					clearInterval(this.setInTime);
					this.showTimes = false
				}, 200);
			},
			// 文档页面
			handleDocument() {
				this.$router.push('/helpCenter')
			},
			// 搜索弹窗
			closeSearchShow(event) {
				var btn = document.querySelector(".right_input");
				// debugger;
				if (btn) {
					if (!btn.contains(event.target)) {
						this.searchShow = false;
					}
				}
			},
			searchShowMessage() {
				this.searchDialogWidth = this.$refs.userName.offsetWidth + 240 + 'px'
				this.searchShow = !this.searchShow;
			},

			startChat() {
				getNewcurrent()
					.then((res) => {
						let newToken = this.$cookies.get("api_token_new");
						if (newToken) {
							this.isStorageUsermessage(res);
							let user = this.$store.state.isUsermessage;
							this.$refs.chatDialogRef.initReply(user.uuid, user.name, user.headUrl);
						} else {
							this.$router.push("/login");
						}

					})
					.catch((err) => {
						console.log(err);
					});
			}
			// getChat(){
			// 	console.log(this.chatFalg)
			// 	if(newToken){
			// 		this.chatFalg = true;
			// 	}else{
			// 		this.$router.push("/login");
			// 	}
			// },
		},
	};
</script>

<style scoped lang="less">
	.navContentClass {
		// padding:0 8% 0 80px;
		box-sizing: border-box;

		.logo {
			// position: absolute;
			// left: 80px;
		}

		// .userInfo{
		//   position: absolute;
		//   right: 8%;
		// }
	}

	.mapName {
		justify-content: space-between;
		height: 100%;
		margin: 0 auto;

		// width: 1200px;
		ul {
			margin: 0;
		}
	}

	.loginul {
		line-height: 88px;
		padding-right: 50px;
	}

	.loginul a {
		color: #d01919;
		font-size: 14px;
	}

	.mapName .li {
		color: rgba(255, 255, 255, 0.7);
		font-size: 16px;
	}

	.mapName .mapNameLi {
		box-shadow: 0 -3px 0 #157efb inset;
		color: #157efb !important;
		line-height: 80px;
	}

	.mapName li:hover {
		transition: 0.5s;
		box-shadow: 0 -3px 0 #157efb inset;
		cursor: pointer;
		line-height: 80px;
	}

	.tittle {
		position: fixed;
		background: #fff;
		box-shadow: 0 -1px 0 #f0f0f0 inset;
		width: 100%;
		height: 80px;
		z-index: 4000;
		justify-content: space-around;
		align-items: center;

		.tittle_ul {
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 16px;

			li {
				color: #000;
				/*font-weight: 700;*/
				/*margin-right: 46px;*/
				width: 100px;
				text-align: center;
			}
		}
	}

	.tittle .logo {
		// margin: 19px 42px 0 38px;
		align-items: center;
		justify-content: center;
		display: flex;

		// flex: 1;
		img {
			height: 50px;
			margin: 8px 0 0 0;
			padding: 0;
		}
	}

	.login {
		justify-content: center;
		align-items: center;
		font-size: 13px;

		// flex: 1;
		.the_login {
			padding: 5px 30px;
			border-radius: 3px;
			color: #157efb;
			border: 1px solid #157efb;
		}

		// :nth-child(2) {
		//   // border: 1px solid #157efb;
		//   margin-left: 27px;
		// }

		.lh90 {
			cursor: pointer;
			font-size: 16px;
			// &:nth-of-type(1) {
			//   margin-right: 20px;
			// }
		}

		.userName {
			cursor: default;
			font-size: 16px;
			width: 210px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}

		.usercenter {
			margin: 0 15px;
			font-size: 16px;
			cursor: pointer;
		}

		.usercenter:hover {
			border-bottom: 1px solid #157efb;
			color: #157efb;
		}
	}

	.right_box {
		align-items: center;
		margin-right: 35px;

		.search {
			position: relative;
			margin-right: 20px;
			text-align: right;

			i:hover {
				color: #157efb;
			}


		}

		.loginText {
			position: relative;

			p {
				cursor: pointer;
				font-size: 16px;
				margin-right: 25px;

				&:hover {
					color: #157efb;
				}
			}
		}
	}

	.worksDi {
		// width: 100%;
		// height: 100%;
		position: relative;
		z-index: 4001;

		.loginMess {
			width: 200px;
			// height: 100px;
			border-radius: 10px;
			background: #fff;
			position: fixed;
			right: 70px;
			top: 70px;
			box-shadow: 0px 3px 6px 2px #c9c9c95c;
			box-sizing: border-box;

			p {
				cursor: pointer;
				padding: 16px;
				margin: 0;
				padding-bottom: 16px;
				border-bottom: 1px solid #efefef;
				animation: text 1s;
				text-align: center;

				&:hover {
					color: #157efb;
				}
			}

			p:nth-last-of-type(1) {
				border: none;
			}
		}
	}

	.flexClass {
		/deep/ .icon-weixin:before {
			content: "\E660";
		}
		/deep/.icon-fenxiang:before {
			  content: "\e605";
			}
	

		.topCharts {
			background: #fff;
			box-shadow: 0px 0px 17px -7px #157efb;
			border-radius: 50%;
			width: 50px;
			height: 50px;
			position: fixed;
			right: 45px;
			bottom: 31%;
			text-align: center;
			line-height: 53px;
			font-size: 27px;
			font-weight: 500;
			font-family: "Avenir", Helvetica, Arial, sans-serif;
			-webkit-font-smoothing: antialiased;
			-moz-osx-font-smoothing: grayscale;
		}

		.topCharts:hover {
			i {
				color: #fff;
			}

			background: #157efb;
		}

		.topCharts:hover:before {
			       width: 60px;
			       height: 20px;
			       content: attr(data-msg);
			       position: absolute;
			       /* padding: 2px 6px; */
			       display: block;
			       color: #333;
			       -webkit-box-shadow: 0 0 5px 1px #a1b9cda6;
			       box-shadow: 0 0 5px 1px #a1b9cda6;
			       border-radius: 5px;
			       font-size: 14px;
			       line-height: 20px;
			       top: 11px;
			       left: -86%;
			       padding: 5px 5px;
			       -webkit-transform: translateX(-50%);
			       -ms-transform: translateX(-50%);
			       transform: translateX(-50%);
			       background: #fff;
		}

		.topCharts:hover:after {
			content: "";
			width: 10px;
			height: 10px;
			color: #333;
			box-shadow: 0px 0px 0px 0px #a1b9cda6;
			position: absolute;
			top: 21px;
			left: -30%;
			transform: rotate(46deg);
			background: #fff;
			line-height: 14px;
			font-size: 14px;
			border-radius: 0 0px 50% 50%;
		}

		.shareImg {
			background: #fff;
			box-shadow: 0px 0px 17px -7px #157efb;
			border-radius: 50%;
			width: 50px;
			height: 50px;
			position: fixed;
			right: 45px;
			bottom: 13%;
			text-align: center;
			line-height: 53px;
			font-size: 27px;
			font-weight: 500;
			font-family: "Avenir", Helvetica, Arial, sans-serif;
			-webkit-font-smoothing: antialiased;
			-moz-osx-font-smoothing: grayscale;
			i{
				color: #000;
			}
		}

		.shareImg:hover {
			background: #157efb;
			i{
				color: #fff;
			}
		}

		.hidden_div {
			background: #fff;
			// width: 140px;
			// height: 100px;
			position: fixed;
			right: 120px;
			bottom: 12%;
			// text-align: center;
			font-size: 14px;
			box-shadow: rgb(0 0 0 / 12%) 0px 1px 3px, rgb(0 0 0 / 24%) 0px 1px 2px;
			padding: 15px;
			border-radius: 5px;

			.root {
				width: 0px;
				height: 0px;
				border: 10px solid transparent;
				border-bottom-color: #fff;
				position: absolute;
				right: -20px;
				bottom: 4%;
				transform: rotate(90deg)
			}

			div {
				align-items: center;
				margin-bottom: 10px;
				cursor: pointer;

				i {
					font-size: 20px;
					vertical-align: middle;
					margin-right: 5px;
				}

				img {
					vertical-align: middle;
				}
			}
		}

		.uploadImg {
			background: #fff;
			box-shadow: 0px 0px 17px -7px #157efb;
			border-radius: 50%;
			width: 50px;
			height: 50px;
			position: fixed;
			right: 45px;
			bottom: 22%;
			text-align: center;
			line-height: 53px;
			font-size: 27px;
			font-weight: 500;
			font-family: "Avenir", Helvetica, Arial, sans-serif;
			-webkit-font-smoothing: antialiased;
			-moz-osx-font-smoothing: grayscale;

		}

		.uploadImg:hover {
			// color: #fff;
			background: #157efb;
		}

		.uploadImg:hover:before {
			   width: 60px;
			    height: 20px;
			    content: attr(data-msg);
			    position: absolute;
			    /* padding: 2px 6px; */
			    display: block;
			    color: #333;
			    -webkit-box-shadow: 0 0 5px 1px #a1b9cda6;
			    box-shadow: 0 0 5px 1px #a1b9cda6;
			    border-radius: 5px;
			    font-size: 14px;
			    line-height: 20px;
			    top: 11px;
			    left: -86%;
			    padding: 5px 5px;
			    -webkit-transform: translateX(-50%);
			    -ms-transform: translateX(-50%);
			    transform: translateX(-50%);
			    background: #fff;
		}

		.uploadImg:hover:after {
			content: "";
			width: 10px;
			height: 10px;
			color: #333;
			box-shadow: 0px 0px 0px 0px #a1b9cda6;
			position: absolute;
			top: 21px;
			left: -30%;
			transform: rotate(46deg);
			background: #fff;
			line-height: 14px;
			font-size: 14px;
			border-radius: 0 0px 50% 50%;
		}

		.topClass {
			background: #fff;
			box-shadow: 0px 0px 17px -7px #157efb;
			border-radius: 50%;
			width: 50px;
			height: 50px;
			position: fixed;
			right: 45px;
			bottom: 13%;
			text-align: center;
			line-height: 53px;
			font-size: 27px;
			font-weight: 500;
			font-family: "Avenir", Helvetica, Arial, sans-serif;
			-webkit-font-smoothing: antialiased;
			-moz-osx-font-smoothing: grayscale;
		}

		.topClass:hover {
			color: #fff;
			background: #157efb;
		}

		.topClass1 {
			background: #fff;
			box-shadow: 0px 0px 17px -7px #157efb;
			border-radius: 50%;
			width: 50px;
			height: 50px;
			position: fixed;
			right: 45px;
			bottom: 22%;
			text-align: center;
			line-height: 53px;
			font-size: 27px;
			font-weight: 500;
			font-family: "Avenir", Helvetica, Arial, sans-serif;
			-webkit-font-smoothing: antialiased;
			-moz-osx-font-smoothing: grayscale;
		}

		.topClass1:hover {
			color: #fff;
			background: #157efb;
		}

		.topClassCheck {
			background: #fff;
			box-shadow: 0px 0px 17px -7px #157efb;
			border-radius: 50%;
			width: 50px;
			height: 50px;
			position: fixed;
			right: 45px;
			bottom: 40%;
			text-align: center;
			line-height: 53px;
			font-size: 27px;
			font-weight: 500;
			font-family: "Avenir", Helvetica, Arial, sans-serif;
			-webkit-font-smoothing: antialiased;
			-moz-osx-font-smoothing: grayscale;
		}

		.topClassCheck:hover {
			i {
				color: #fff;
			}

			background: #157efb;
		}

		.topClassCheck:hover:before {
			width: 60px;
			    height: 20px;
			    content: attr(data-msg);
			    position: absolute;
			    /* padding: 2px 6px; */
			    display: block;
			    color: #333;
			    -webkit-box-shadow: 0 0 5px 1px #a1b9cda6;
			    box-shadow: 0 0 5px 1px #a1b9cda6;
			    border-radius: 5px;
			    font-size: 14px;
			    line-height: 20px;
			    top: 11px;
			    left: -86%;
			    padding: 5px 5px;
			    -webkit-transform: translateX(-50%);
			    -ms-transform: translateX(-50%);
			    transform: translateX(-50%);
			    background: #fff;
		}

		.topClassCheck:hover:after {
			content: "";
			width: 10px;
			height: 10px;
			color: #333;
			box-shadow: 0px 0px 0px 0px #a1b9cda6;
			position: absolute;
			top: 21px;
			left: -30%;
			transform: rotate(46deg);
			background: #fff;
			line-height: 14px;
			font-size: 14px;
			border-radius: 0 0px 50% 50%;
		}

		.topClassWeiXin {
			background: #fff;
			box-shadow: 0px 0px 17px -7px #157efb;
			border-radius: 50%;
			width: 50px;
			height: 50px;
			position: fixed;
			/*position:relative;*/
			right: 45px;
			bottom: 49%;
			text-align: center;
			line-height: 53px;
			font-size: 27px;
			font-weight: 500;
			font-family: "Avenir", Helvetica, Arial, sans-serif;
			-webkit-font-smoothing: antialiased;
			-moz-osx-font-smoothing: grayscale;
		}

		.topClassWeiXin:hover {
			color: #fff;
			background: #157efb;
		}
	}

	.userMessageBox {
		position: fixed;
		width: 100%;
		z-index: 4001;
		height: 100%;
	}

	.userMessage {
		position: absolute;
		top: 70px;
		right: 24px;
		background: #fff;
		box-shadow: 0px 3px 6px 2px #c9c9c95c;
		box-sizing: border-box;
		// animation: show 1s;
		border-radius: 10px;
		padding: 20px;

		// width: 463px;
		img {
			width: 50px;
			height: 50px;
			border-radius: 50%;
			margin-right: 16px;
			cursor: pointer;
		}

		.userMes {

			// width: 100%;
			h4 {
				font-size: 13px;
				margin-bottom: 10px;
				cursor: pointer;

				&:hover {
					color: #157efb;
				}
			}

			.userMesBox {
				align-items: center;
				white-space: normal;
				justify-content: space-between;

				white-space:nowrap p {
					margin: 0;
					white-space: nowrap;
					font-size: 14px;
				}

				.userMesNames {
					margin-right: 42px;

					p {
						padding: 2px 14px;
						border-radius: 20px;
						cursor: default;
						white-space: nowrap;
						font-size: 12px;
					}

					p:nth-of-type(1) {
						background: #05930a25;
						color: #05930a;
						margin-right: 10px;
					}

					p:nth-of-type(2) {
						background: #a5891748;
						color: #a58917;
						margin-right: 10px;
					}

					p:nth-of-type(3) {
						background: #157dfb45;
						color: #157efb;
						margin-right: 10px;
					}
				}
			}
		}

		.noUser {
			cursor: pointer;
			border: none;
			color: #ff9100;
			font-size: 13px;
		}

		.noUser:hover {
			color: #d01919;
		}
	}

	.searchDialog {
		position: fixed;
		width: 100%;
		height: 100%;
		z-index: 9999;

		.right_input {
			position: absolute;
			top: 23px;
			right: 24px;
		}

		/deep/ .el-input__inner {
			border-radius: 40px;
			height: 30px;
			line-height: 30px;
		}

		/deep/ .el-input {
			width: 200px;
			animation: move 1s;
		}

		@keyframes move {
			0% {
				width: 0px;
			}

			100% {
				width: 200px;
			}
		}

		/deep/ .el-input__icon {
			line-height: 30px;
		}
	}

	.scanCode {
		font-size: 14px;
		display: block;
		margin-top: -17px;
		font-size: 13px;
		color: black;
		font-family: Microsoft YaHei, PingFang SC, Lantinghei SC, Helvetica Neue, Helvetica, Arial, \\5FAE\8F6F\96C5\9ED1, STHeitiSC-Light, simsun, \\5B8B\4F53, WenQuanYi Zen Hei, WenQuanYi Micro Hei, "sans-serif";
	}

	.scanCode1 {
		font-size: 16px;
		display: block;
		// margin-top: -17px;
		color: black;
		font-family: Microsoft YaHei, PingFang SC, Lantinghei SC, Helvetica Neue, Helvetica, Arial, \\5FAE\8F6F\96C5\9ED1, STHeitiSC-Light, simsun, \\5B8B\4F53, WenQuanYi Zen Hei, WenQuanYi Micro Hei, "sans-serif";
	}

	.scanCode1:hover {
		color: #157efb;
	}
		
			
</style>



// WEBPACK FOOTER //
// src/components/header/nap.vue